import React, { Component } from 'react';
import { Spin, Row, Button, Col } from 'antd';
import { app, api } from "../../../app";

class TeamPublicDetail extends Component {
    constructor (props) {
        super(props);
        this.state = {
            dataInfo: {},
            data_loading: true,
            id: props.match.params.id
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @returns {Promise<void>}
     */
    handleData = async () => {
        let { id } = this.state, { flag, data, msg } = await app.post(api.TeamOpenDetails, { id });
        let state = { data_loading: false };
        if (flag === 1) {
            state.dataInfo = data;
        } else {
            app.alert(msg, "error");
        }
        this.setData(state);
    };

    render () {
        let { data_loading, dataInfo } = this.state;
        return (
            <div className="mien-page">
                <Row className="mien-title" type="flex" justify="space-between">
                    <span>队伍公开详情（{dataInfo.teamname || "正在加载 ..."}）</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <Row className="no-data" type="flex" justify="center" align="middle"
                     hidden={!data_loading}><Spin/></Row>
                <div className="pp-content" hidden={data_loading}>
                    <h1 style={{ textAlign: "center" }}>{dataInfo.open_title}</h1>
                    <Row type="flex" justify="space-between"
                         style={{ color: "#999", padding: "20px 0", borderTop: "1px solid #ddd" }}>
                        <Col>
                            <span>发布日期: {dataInfo.submit_time}</span>
                            <span style={{ marginLeft: 20 }}>发布人:{dataInfo.vname}</span>
                        </Col>
                        <Col>公开类别: {dataInfo.open_class_name}</Col>
                    </Row>
                    <p>{dataInfo.open_content}</p>
                </div>
            </div>
        );
    }
}

export default TeamPublicDetail;



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamPublicDetail.jsx